module.exports = __webpack_public_path__ + "img/discount.bbde6b19.svg";